// passing the path into variables

const destination1 = '/assets/serenamar/destination/coquimbo.png'
const destination2 = '/assets/serenamar/destination/huasco.png'
const destination3 = '/assets/serenamar/destination/la-serena.png'
const destination4 = '/assets/serenamar/destination/ovalle.png'
const destination5 = '/assets/serenamar/destination/santiago.png'
const destination6 = '/assets/serenamar/destination/vallenar.png'


const gallery1 = '/assets/serenamar/home/bus1.png'
const gallery2 = '/assets/serenamar/home/bus2.png'
const gallery3 = '/assets/serenamar/home/bus3.png'


const destination = [destination1, destination2, destination3, destination4, destination5, destination6];

const gallery = [gallery1, gallery2, gallery3];



const serenamarSlides = {
    destination,
    gallery
}

export default serenamarSlides


// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/serenamarSlides.js